import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { InputWithLabelAndError } from "components/ui/InputWithLabelAndError";
import { resetPassword } from "helpers/apiClient";

const ForgotPasswordResetFrame = () => {
  const [formData, setFormData] = useState({ newPassword: "", confirmPassword: "" });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const resetToken = params.get("token") || params.get("resToken") || params.get("resetToken");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!formData.newPassword) nextErrors.newPassword = "Se necesita una nueva contraseña.";
    if (formData.newPassword !== formData.confirmPassword) nextErrors.confirmPassword = "Las contraseñas no coinciden.";
    if (!resetToken) nextErrors.resetToken = "No se encontró el token de invitación.";
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length || isLoading) return;

    setIsLoading(true);
    setMessage("");
    try {
      await resetPassword({ resetToken, newPassword: formData.newPassword });
      setMessage("Contraseña creada correctamente. Ya puedes iniciar sesión.");
      setSucceeded(true);
    } catch (error) {
      if (error.status === 401) {
        setMessage("El enlace no es válido, ha caducado o ya fue utilizado.");
      } else if (error.status === 400) {
        setMessage("La contraseña no cumple los requisitos del servidor.");
      } else {
        setMessage(error.message || "No se ha podido conectar con el servidor.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const update = (event) => setFormData((current) => ({ ...current, [event.target.name]: event.target.value }));

  return (
    <div className="max-w-md w-full flex flex-col gap-y-4 md:gap-y-8">
      <h2 className="font-medium leading-7 dark:text-white">Crear contraseña</h2>
      <p className="text-sm text-gray-600 dark:text-gray-300">Elige una contraseña que solo tú conozcas para acceder a HortaTech.</p>
      {!succeeded && (
        <form className="flex flex-col gap-y-4" onSubmit={handleSubmit}>
          <InputWithLabelAndError value={formData.newPassword} onChange={update} type="password" name="newPassword" label="Contraseña" placeholder="••••••••" hasFloatingLabel={false} error={errors.newPassword} />
          <InputWithLabelAndError value={formData.confirmPassword} onChange={update} type="password" name="confirmPassword" label="Confirmar contraseña" placeholder="••••••••" hasFloatingLabel={false} error={errors.confirmPassword || errors.resetToken} />
          <button type="submit" disabled={isLoading} className="mt-2 w-full bg-[#1D91E0] text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600 disabled:opacity-50">
            {isLoading ? "Creando contraseña..." : "Crear contraseña"}
          </button>
        </form>
      )}
      {message && <p role="status" className={succeeded ? "text-green-600" : "text-red-500"}>{message}</p>}
      <div className="lg:flex lg:justify-center">
        <p className="text-sm dark:text-white text-center">
          <Link to="/login" className="inline-block text-center text-[#1D91E0] hover:text-blue-600">Iniciar sesión</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordResetFrame;
